import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import "./index.scss";

import ProfileAvatar from "../../../../../components/ui/ProfileAvatar";
import ContentBox from "../../../../../components/ui/ContentBox";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import Pagination from "../../../../../components/ui/Pagination";
import PaginationArrow from "../../../../../components/ui/PaginationArrow";
import Button from "../../../../../components/ui/Button";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import OverflowText from "../../../../../components/ui/Textoverflow";

import ListFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/ListFilter";
import EndpointsFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/EndpointFilter";

import { plusIcon, minusIcon, searchIcon, credentialsCloseIcon, credentialsOpenIcon } from "../../../../../utils/icons";
import { formatDate, formatNumber, getLeakedCredntialsImageUrl } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getLeakedCredentials, getLeakedCredentialsDataList, getScanInfoStats, resetScanInfoStats } from "../../../../../store/actions/scanInfoAction";

import apiEndpoints from "../../../../../apiEndpoints";

const LeakedCredentials = () => {

    const leakedCredentialsListResponse = useSelector((state) => state.scanInfo?.leakedCredentialsList);
    const leakedCredentialsDataResponse = useSelector((state) => state.scanInfo?.leakedCredentialsData);
    const leakedCredentialsStatsResponse = useSelector((state) => state.scanInfo?.scanInfoStats);

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
        triggerListFetch,
        setTriggerListFetch,
        setContextCurrentPage
    } = useScanInfoContext();

    const [activeContent, setActiveContent] = useState("affectedEndpoints");
    const [selectedLeakedCred, setSelectedLeakedCred] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isEndpointLoading, setIsEndpointLoading] = useState(false);
    const [visiblePasswordId, setVisiblePasswordId] = useState(null);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [listCurrentPage, setListCurrentPage] = useState(1);
    const [leakedCredentialsStats, setLeakedCredentialsStats] = useState("");
    const [showViewAllModal, setShowViewAllModal] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);

    //list search state
    const [listSearch, setListSearch] = useState("");
    const [updatedListSearchValue, setUpdatedListSearchValue] = useState("");

    //affected endpoint search state
    const [endpointSearch, setEndpointSearch] = useState("");
    const [endpointsQuery, setEndpointsQuery] = useState("");
    const [endpointSearchFocused, setEndpointSearchFocused] = useState(false);

    //selected list filter
    const [listFilterValue, setListFilterValue] = useState({});

    //endpoint filter
    const [endpointFiltersValue, setEndpointFiltersValue] = useState({})

    const handlePageChange = (newPage) => {
        setListCurrentPage(newPage);
        setContextCurrentPage(newPage);
        setTriggerListFetch(true);
    };

    const hidePassword = (data) => {
        if (data.length <= 2) {
            return data; // Return as is if the length is 2 or less
        }
    
        const firstChar = data[0]; // First character
        const lastChar = data[data.length - 1]; // Last character
        const middle = '*'.repeat(data.length - 2); // Replace middle characters with '*'
    
        return `${firstChar}${middle}${lastChar}`;
    }

    const showPassword = (id) => {
        if (visiblePasswordId === id) {
            setVisiblePasswordId(null); // Hide password if clicked again
        } else {
            setVisiblePasswordId(id); // Show password for the clicked row
        }
    };

    const showContent = (data) => {  
        if(activeContent === data) {
            setActiveContent("")
        } else {
            setActiveContent(data)
            if(data === "affectedEndpoints") {
                fetchAffectedEndPoints()
            }
        }
    }
    
    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && endpointSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setEndpointsQuery(endpointSearch)
    }

    const listFilterApply = (data) => {
        setListCurrentPage(1);
        setListFilterValue(data);
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const isAnyFilterActive = Object.values(listFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setListCurrentPage(1);
        setListFilterValue({});
        setContextCurrentPage(1);
        setTriggerListFetch(true);
    }

    const fetchLeakedCredentialsStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.exposureManagemnet.darkWeb.leakedCredentialsStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getScanInfoStats(url))
    },[dispatch, domainId, scanId, organizationId])

    const endPointFilterApply = (data) => {
        setEndpointFiltersValue(data)
    }

    const isAnyEndpointFilterActive = Object.values(endpointFiltersValue).some(value => Boolean(value));

    const resetEndpointFilterValue = () => {
        setCurrentPage(1)
        setEndpointFiltersValue({})
    }

    const fetchAffectedEndPoints = useCallback(()=>{
        setIsEndpointLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&domain=${selectedLeakedCred?.domain}&scan_id=${selectedLeakedCred?.scan_id}&result_id=${selectedLeakedCred?.id}`;
        const queryParams = endpointsQuery ? `&query=${endpointsQuery}`: "";
        const newFindings = endpointFiltersValue?.newFindings?.value && endpointFiltersValue?.newFindings?.value !== "all" ? `&new_record=${endpointFiltersValue?.newFindings?.value === "yes" ? true : false}` : "";
        const emailStatus = endpointFiltersValue?.emailStatus?.value && endpointFiltersValue?.emailStatus?.value !== "all" ? `&email_status=${endpointFiltersValue?.emailStatus?.value}` : "";
        const url = `${baseUrl}${queryParams}${newFindings}${emailStatus}`
        dispatch(getLeakedCredentialsDataList(url))
    },[dispatch, currentPage, currentPageSize, selectedLeakedCred, endpointsQuery, endpointFiltersValue])

    const requestSearch = useMemo(() => debounce((searchTerm) => {        
        setUpdatedListSearchValue(searchTerm)
    }, 500), []);

    const fetchLeakedCredList = useCallback(()=>{
        setIsLoading(true)
        setScanNotFound(false)
        const baseUrl = `&page=${listCurrentPage}&page_size=10`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = updatedListSearchValue ? `&query=${updatedListSearchValue}` : "";
        const newFindings = listFilterValue?.newFindings?.value && listFilterValue?.newFindings?.value !== "all" ? `&new_record=${listFilterValue?.newFindings?.value === "yes" ? true : false}` : "";
        const emailStatus = listFilterValue?.emailStatus?.value && listFilterValue?.emailStatus?.value !== "all" ? `&email_status=${listFilterValue?.emailStatus?.value}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}${emailStatus}`
        dispatch(getLeakedCredentials(url))
    },[dispatch, domainId, scanId, organizationId, listCurrentPage, updatedListSearchValue, listFilterValue])

    useEffect(() => {
        if (selectedLeakedCred) {
            setCurrentPage(1);            
        }
    }, [selectedLeakedCred]);

    useEffect(()=>{
        if(selectedLeakedCred?.id) {
            fetchAffectedEndPoints()
        }        
    },[currentPage, selectedLeakedCred, fetchAffectedEndPoints])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchLeakedCredentialsStats();
            setListCurrentPage(1)
            setContextCurrentPage(1)
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setContextCurrentPage, setTriggerStatsFetch, fetchLeakedCredentialsStats]);

    useEffect(() => {
        if (triggerListFetch) {
            fetchLeakedCredList();
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, fetchLeakedCredList]);

    useEffect(() => {
        setListCurrentPage(1); // reset to first page
        setContextCurrentPage(1);
        setTriggerListFetch(true); // trigger fetch
    }, [setTriggerListFetch, setContextCurrentPage, updatedListSearchValue]);

    useEffect(()=>{
        if(leakedCredentialsListResponse !== null) {
            if(leakedCredentialsListResponse?.status === "failed") {
                setScanNotFound(true)
            }
            if(leakedCredentialsListResponse?.results?.length > 0) {
                setIsEndpointLoading(true)
                setScanNotFound(false)
                setSelectedLeakedCred(leakedCredentialsListResponse?.results[0]);
            }
            setIsLoading(false)
        }
    },[leakedCredentialsListResponse])

    useEffect(()=>{
        if(leakedCredentialsDataResponse !== null) {            
            setIsEndpointLoading(false)
        }
    },[leakedCredentialsDataResponse])

    useEffect(()=>{  
        if(leakedCredentialsStatsResponse !== null) {
            setStatsLoading(false)
            setLeakedCredentialsStats(leakedCredentialsStatsResponse)
            dispatch(resetScanInfoStats())
        }
    },[leakedCredentialsStatsResponse, dispatch])


    return (
        <>
            <div className="scan-info-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>
                        <Col lg={4}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"leakedCredentials"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Leaked Credentials</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(leakedCredentialsStats?.record_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Records</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(leakedCredentialsStats?.record_type?.new_record)}</span> New</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(leakedCredentialsStats?.record_type?.existing_record)}</span> Existing</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>                                                
                        <Col lg={4}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"leakedCredentials"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="discover-doamin-container associated-doamin-page ports-container rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Email Status</p>
                                        </div>
                                        <div className="d-flex gap-3">
                                            <div className="total-score-container rounded">
                                                <div className="users-totol-count d-flex">
                                                    <p className="total-score-count">{formatNumber(leakedCredentialsStats?.email_status_type?.total)}</p>
                                                    <div className="score-count mx-3">
                                                        <span className="new-record d-inline-block mx-1"></span>
                                                        <span className="existing-record d-inline-block"></span>
                                                        <p>Total Records</p>
                                                    </div>
                                                </div>
                                                <div className="new-exist-count d-flex gap-5 mt-3">
                                                    <p className="new-record"><span className="d-inline-block">{formatNumber(leakedCredentialsStats?.email_status_type?.active)}</span> Active</p>
                                                    <p className="existing-record"><span className="d-inline-block">{formatNumber(leakedCredentialsStats?.email_status_type?.inactive)}</span> Inactive</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={4}>
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"leakedCredentials"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="sub-domain-type-container web-server-type-container rounded p-3 h-100">
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Leak Name</p>
                                            {leakedCredentialsStats !== "" && leakedCredentialsStats?.leaked_credential_type?.records && Object.entries(leakedCredentialsStats?.leaked_credential_type?.records).length > 4 && <p className="view-all" onClick={()=>{setShowViewAllModal(true)}}>View all</p>}
                                        </div>
                                        <div className="total-records-container">
                                            <p className="content">{formatNumber(leakedCredentialsStats?.leaked_credential_type?.total)} <span>Total Records</span></p>
                                        </div>
                                        <div className="sub-domain-content">
                                            <Row>
                                                {
                                                    leakedCredentialsStats !== "" && leakedCredentialsStats?.leaked_credential_type?.records && Object.entries(leakedCredentialsStats?.leaked_credential_type?.records).length > 0 &&
                                                    Object.entries(leakedCredentialsStats?.leaked_credential_type?.records).map(([key, value], index) => {
                                                        if(index <= 3) {
                                                            return (
                                                                <Col lg={6} className="mt-3" key={index}>
                                                                    <div className="d-flex align-items-center gap-3">
                                                                        <p className="count-type">{formatNumber(value)}</p>
                                                                        <ProfileAvatar type="domain" name={key} imageUrl={getLeakedCredntialsImageUrl(key)} />
                                                                    </div>
                                                                </Col>
                                                            )
                                                        }
                                                        return null;
                                                    })
                                                }
                                            </Row>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={3}>
                            <div className="bg-white-with-shadow subdomain-list-container h-100">
                                <div className="list-heading px-3 pt-3 d-flex justify-content-between align-items-center">
                                    <h1>Leaked Credentials List</h1>
                                    {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                    <ListFilter listFilterApply={listFilterApply} listFilterValue={listFilterValue} currentPage={"leakedCredentials"} />
                                </div>
                                <div className="search-container px-3 position-relative">
                                    <span className="position-absolute search-icon">{searchIcon()}</span>
                                    <input type="text" 
                                        placeholder="Search" 
                                        className="w-100 rounded input"
                                        value={listSearch}
                                        onChange={(e)=>{                                            
                                            setListSearch(e.target.value);
                                            requestSearch(e.target.value);
                                            setListCurrentPage(1);
                                            setContextCurrentPage(1);
                                            setTriggerListFetch(true);
                                        }}
                                    />
                                </div>
                                <div className="list-main-container">
                                    { !isLoading && scanNotFound &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={leakedCredentialsListResponse?.description}/>
                                        </motion.div>
                                    }
                                    {
                                        isLoading && !scanNotFound ?
                                        <SkeletonLoader type={"line"} count={5} currentPage={"leakedCredentials"} />
                                        :
                                        (
                                            leakedCredentialsListResponse?.results?.length > 0 &&
                                            leakedCredentialsListResponse?.results?.map((data, index) => {
                                                return (
                                                    <motion.div
                                                        key={index}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                    >
                                                        <div className={`sub-domain-list py-2 px-3 ${selectedLeakedCred.id === data?.id ? "active" : ""}`} onClick={()=>{
                                                            resetEndpointFilterValue()
                                                            setSelectedLeakedCred(data)
                                                            }} key={index}>
                                                            <div className={`d-flex align-items-center subdomain-name gap-2 mb-2 ${!data?.new_record ? "full-width" : ""}`}>
                                                                <OverflowText text={data?.leak_title} className={"sub-domain-heading"}/>
                                                                {data.new_record && <span className="new-subdomain">New</span>}
                                                            </div>
                                                            <p className="sub-domain-name">{data?.domain}</p>
                                                            {/* <p className="sub-domain-heading">Employee: 12/50</p> */}
                                                        </div>
                                                    </motion.div>
                                                )
                                            })
                                        )
                                    }
                                    { !isLoading && leakedCredentialsListResponse?.results?.length > 0 &&
                                        <PaginationArrow 
                                            totalCount={leakedCredentialsListResponse?.meta?.total_results}
                                            currentPage={listCurrentPage}
                                            onPageChange={handlePageChange}
                                        />
                                    }
                                    { !isLoading && leakedCredentialsListResponse?.results?.length === 0 &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={"No Data Found"} />
                                        </motion.div>
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col lg={9}>
                            <div className="main-content bg-white-with-shadow p-2 h-100">
                                {
                                    !isLoading && scanNotFound ?
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        <NoDataFound noDataText={leakedCredentialsListResponse?.description}/>
                                    </motion.div>
                                    :
                                    (
                                        !isLoading && leakedCredentialsListResponse?.results?.length === 0 ?
                                            <motion.div
                                                initial={{ opacity: 0, y: 20 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                transition={{ duration: 0.4 }}
                                            >
                                                <NoDataFound noDataText={"No Data Found"}/>
                                            </motion.div>
                                        :
                                        <>
                                            <div className="record-container-content p-2">
                                                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{showContent("jsSecretsSummary")}}>
                                                    <h2 className="heading">Leaked Credentials Summary</h2>
                                                    {activeContent === "jsSecretsSummary" ? minusIcon() : plusIcon()}
                                                </div>
                                                {
                                                    isLoading && activeContent === "jsSecretsSummary" ?
                                                        <SkeletonLoader type={"line"} count={5} currentPage={"sensitiveExpo"} />
                                                    :
                                                    <>
                                                        {activeContent === "jsSecretsSummary" && <div className="js-secrete-summary mt-3">
                                                            <motion.div
                                                                initial={{ opacity: 0, y: 20 }}
                                                                animate={{ opacity: 1, y: 0 }}
                                                                transition={{ duration: 0.4 }}
                                                            >
                                                                <Row>
                                                                    <Col lg={6} className="mb-3">
                                                                        <ContentBox label={"Name"} value={selectedLeakedCred?.leak_name} />
                                                                    </Col>
                                                                    <Col lg={6} className="mb-3">
                                                                        <ContentBox label={"Description"} value={selectedLeakedCred?.leak_description} />
                                                                    </Col>
                                                                    <Col lg={6} className="mb-3">
                                                                        <ContentBox label={"Domain"} value={selectedLeakedCred?.leak_domain} />
                                                                    </Col>
                                                                    <Col lg={6} className="mb-3">
                                                                        <ContentBox label={"Date"} value={formatDate(selectedLeakedCred?.leak_date, "date")} />
                                                                    </Col>
                                                                    <Col lg={6} className="mb-3">
                                                                        {selectedLeakedCred !== "" && <ContentBox label={"Data Classess"} value={selectedLeakedCred?.leak_data_classes.join(", ")} />}
                                                                    </Col>
                                                                </Row>
                                                            </motion.div>
                                                        </div> }
                                                    </>
                                                }                              
                                            </div>
                                            <div className="record-container-content p-2 mt-3">
                                                <div className="tab-header-container d-flex justify-content-between align-items-center" onClick={()=>{showContent("affectedEndpoints")}}>
                                                    <h2 className="heading">Leaked Data</h2>
                                                    {activeContent === "affectedEndpoints" ? minusIcon() : plusIcon()}
                                                </div>
                                                {activeContent === "affectedEndpoints" && <div className="affected-endpoint-container">
                                                    <div className="git-leaks-main-content">
                                                        <div className="search-header-container d-flex align-items-center gap-3 my-3">
                                                            <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                                                                <div className="search-container position-relative">
                                                                    <span className="position-absolute">{searchIcon()}</span>
                                                                    <input type="text" 
                                                                        placeholder="Search" 
                                                                        value={endpointSearch} 
                                                                        onChange={(e)=>{
                                                                            setEndpointSearch(e.target.value)
                                                                        }}
                                                                        onFocus={() => setEndpointSearchFocused(true)}
                                                                        onBlur={() => setEndpointSearchFocused(false)}
                                                                    />
                                                                </div>
                                                                <button className="search-btn" onClick={onSearch}>Search</button>
                                                            </div>
                                                            <EndpointsFilter endPointFilterApply={endPointFilterApply} endpointFiltersValue={endpointFiltersValue} currentPage={"leakedCredentials"} />
                                                            {isAnyEndpointFilterActive && (<span className="reset-filter-link" onClick={resetEndpointFilterValue}>Reset Filter</span>)}
                                                        </div>
                                                        <div className="js-secrets-table">
                                                            {
                                                                isLoading || isEndpointLoading ?
                                                                <SkeletonLoader type={"line"} count={5} currentPage={"leakedCredentials"} />
                                                                :
                                                                <Table responsive="lg">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Email</th>
                                                                            <th>Username</th>
                                                                            <th>Password/Hash Password</th>
                                                                            <th>Status</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            leakedCredentialsDataResponse?.results?.length > 0 &&
                                                                            leakedCredentialsDataResponse?.results?.map((data, index) => {
                                                                                return (
                                                                                    <motion.tr
                                                                                        key={index}
                                                                                        initial={{ opacity: 0, y: 20 }}
                                                                                        animate={{ opacity: 1, y: 0 }}
                                                                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                                                                    >
                                                                                        <td>
                                                                                            <p>{data?.email}</p>
                                                                                            {data?.new_record && <p className="d-inline-block new-data my-2">New</p>}
                                                                                        </td>
                                                                                        <td>
                                                                                        {data?.username !== null && data?.username !== "" ? data?.username : "-"}
                                                                                        </td>
                                                                                        <td>
                                                                                            {data?.password !== null && data?.password !== "" ? <p className="password-data">
                                                                                                {visiblePasswordId === data.id
                                                                                                    ? data?.password
                                                                                                    : hidePassword(data?.password)}
                                                                                                <span onClick={() => 
                                                                                                    showPassword(data.id)
                                                                                                    }>{visiblePasswordId === data.id ? credentialsOpenIcon() : credentialsCloseIcon()}</span>
                                                                                            </p> : "-"}
                                                                                        </td>
                                                                                        <td>
                                                                                            {data?.email_status === "active" && <p className="status-close">{data?.email_status}</p>}
                                                                                            {data?.email_status === "inactive" && <p className="status-open">{data?.email_status}</p>}
                                                                                            {(data?.email_status === null || data?.email_status === "") && "-"}
                                                                                        </td>
                                                                                    </motion.tr>
                                                                                )
                                                                            })
                                                                        }
                                                                    </tbody>
                                                                </Table>
                                                            }
                                                            {
                                                                !isEndpointLoading && leakedCredentialsDataResponse !== "" && leakedCredentialsDataResponse?.results?.length === 0 && 
                                                                <motion.div
                                                                    initial={{ opacity: 0, y: 20 }}
                                                                    animate={{ opacity: 1, y: 0 }}
                                                                    transition={{ duration: 0.4 }}
                                                                >
                                                                    <NoDataFound noDataText={"No Record Found"}/>
                                                                </motion.div>
                                                            }
                                                            {leakedCredentialsDataResponse !== "" && leakedCredentialsDataResponse?.results?.length > 0 && <Pagination
                                                                className="pagination-bar"
                                                                currentPage={currentPage}
                                                                pageSize={currentPageSize}
                                                                totalCount={leakedCredentialsDataResponse?.meta?.total_results}
                                                                onPageChange={setCurrentPageandRecordSize}
                                                            />}                                        
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>
                                        </>
                                    )
                                }                                
                            </div>
                        </Col>
                    </Row>
                    <Modal
                        show={showViewAllModal}
                        onHide={()=>setShowViewAllModal(false)}
                        size="md"
                        centered
                        className=""
                        >
                            <Modal.Body>
                                <div className="delete-organization-container">
                                    <h4>Leak Name</h4>
                                    <div className="p-2 m-2 type-list-container">
                                        <div className="mt-3">
                                            {
                                                leakedCredentialsStats !== "" && leakedCredentialsStats?.leaked_credential_type?.records && Object.entries(leakedCredentialsStats?.leaked_credential_type?.records).length > 0 &&
                                                Object.entries(leakedCredentialsStats?.leaked_credential_type?.records).map(([key, value], index) => {
                                                    return (
                                                        <div key={index} className="d-flex align-items-center justify-content-between gap-3 p-3 border-bottom scan-info-type-modal">
                                                            <ProfileAvatar type="domain" name={key} imageUrl={getLeakedCredntialsImageUrl(key)} />
                                                            <p className="count-type total-count">{formatNumber(value)}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center gap-3 mt-4">
                                        <div className="w-50">
                                            <Button buttonText="Close" buttonType={"secondary"} buttonClicked={()=>setShowViewAllModal(false)}/>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                    </Modal>
                </div>
            </div>
        </>        
    )
}


export default LeakedCredentials;